import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { BaseDialog } from 'src/components/common';
import { MsCodeForm } from './MsCodeForm';
import { MsRecoveryCodeForm } from './MsRecoveryCodeForm';
import { ILoginModel } from '../../../../../api/base/Auth/types';

export const useStyles = makeStyles(() => ({
  root: {},
}));

type PMsCodeModal = {
  onConfirm: (data: ILoginModel) => void;
  onClose: any;
  open: boolean;
  loading?: boolean;
};

enum ModalTypes {
  CODE,
  RECOVERY_CODE,
}

export const MsCodeModal: React.FC<PMsCodeModal> = (props) => {
  const { open, onClose, onConfirm, loading } = props;
  const [modalType, setModalType] = useState(ModalTypes.CODE);

  return (
    <BaseDialog
      open={open}
      paperStyles={{ maxWidth: '400px', width: '100%' }}
      onClose={onClose}
      title="Microsoft authenticator"
    >
      {modalType === ModalTypes.CODE && (
        <MsCodeForm
          onUseRecoveryCode={() => {
            setModalType(ModalTypes.RECOVERY_CODE);
          }}
          onSubmit={onConfirm}
          loading={loading}
        />
      )}

      {modalType === ModalTypes.RECOVERY_CODE && (
        <MsRecoveryCodeForm
          onUseCode={() => {
            setModalType(ModalTypes.CODE);
          }}
          onSubmit={onConfirm}
          loading={loading}
        />
      )}
    </BaseDialog>
  );
};
